import { render, staticRenderFns } from "./UpdateProductPrice.vue?vue&type=template&id=52dcea56&"
import script from "./UpdateProductPrice.vue?vue&type=script&lang=js&"
export * from "./UpdateProductPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports